import { faSearch, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React, { useState } from "react";
import { getFormValues } from "redux-form";

import { FormValues } from "@/mk2/apps/adminclub/containers/XMLImportItems/StrollerVariantConfigurationForm";
import { CONFIGURATION_FORM_NAME } from "@/mk2/apps/adminclub/containers/XMLImportItems/XMLImportItems.constants";
import { ClearableInput } from "@/mk2/components/ClearableInput";
import { Form } from "@/mk2/components/Form";
import { mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { BZ2_SEARCH_BUTTON, BZ2_SEARCH_IN_ALL } from "@/mk/autogenerated/translations/TextSearchForm.d7cca7360013a465c445acdfa4ff0291";

import styles from "./TextSearch.mscss";

const TEXT_SEARCH_FORM_NAME = "TEXT_SEARCH_FORM_NAME";
export interface TextSearchFormData {
    query: string;
}

interface OwnProps {
    className?: string;
    value?: string;
    placeholder?: string;
    hideButtonUntilFocused?: boolean;
    outlined?: boolean;
    buttonLabel?: React.ReactNode;
    onChange?(value: string);
}

type Props = OwnProps;

const TextSearchFormComponent: React.FunctionComponent<Props> = ({
    className,
    value = "",
    onChange,
    placeholder = BZ2_SEARCH_IN_ALL,
    hideButtonUntilFocused = false,
    outlined = false,
    buttonLabel,
}) => {
    // TODO refactor to use ReduxForm
    const [showButton, setShowButton] = useState(!hideButtonUntilFocused);
    const [active, setActive] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const [previousValue, setPreviousValue] = useState(value);

    if (previousValue !== value) {
        // getDerivedStateFromProps
        setLocalValue(value);
        setPreviousValue(value);
    }

    const onFocus = useEventCallback(
        (event: React.FocusEvent<HTMLInputElement>) => {
            setActive(true);
            setShowButton(true);
        },
        [setActive, setShowButton],
    );

    const onBlur = useEventCallback(
        (event: React.FocusEvent<HTMLInputElement>) => {
            setActive(false);
        },
        [setActive],
    );

    const onLocalChange = useEventCallback(
        (event: React.FormEvent<HTMLInputElement>) => {
            setLocalValue(event.currentTarget.value);
        },
        [setLocalValue],
    );

    const onClear = useEventCallback(
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();
            setLocalValue("");
            if (onChange) {
                onChange("");
            }
        },
        [setLocalValue, onChange],
    );

    const onSubmit = useEventCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            if (onChange) {
                onChange(localValue);
            }
        },
        [onChange, localValue],
    );

    return (
        <Form className={cx(styles.TextSearch, className)} onSubmit={onSubmit}>
            <ClearableInput
                className={cx(
                    styles.TextSearch__input,
                    active && styles["TextSearch__input--active"],
                    value && styles["TextSearch__input--hasValue"],
                )}
                icon={<FontAwesomeIcon icon={faSearch} flip="horizontal" />}
                clearIcon={
                    <FontAwesomeIcon
                        icon={faTimesCircle}
                        className={styles.TextSearch__clearIcon}
                    />
                }
                hasValue={Boolean(value)}
                onClear={onClear}
                outlined={outlined}
            >
                <input
                    className={styles.TextSearch__input__input}
                    type="text"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={onLocalChange}
                    placeholder={placeholder}
                    value={localValue}
                />
            </ClearableInput>
            {showButton && (
                <button className={styles.TextSearch__submit}>
                    {buttonLabel || BZ2_SEARCH_BUTTON}
                </button>
            )}
        </Form>
    );
};

export const TextSearchForm = mkReduxForm<TextSearchFormData, Props>({
    formName: TEXT_SEARCH_FORM_NAME,
    onValidate: () => ({
        /* not implemented */
    }),
    onSave: (values, props) => {
        /* not implemented */
    },
})(TextSearchFormComponent);
